import { Camera } from 'types/camera';
import { IconType } from 'types/icon';
import { Stream } from 'types/stream';

export function getVideoSourceIcon(videoSource: Camera | Stream): IconType {
  if ('conn_type' in videoSource) {
    return 'camera';
  }

  switch (videoSource.stream_type) {
    case 'file':
      return 'file';
    default:
      return 'stream';
  }
}
